// extracted by mini-css-extract-plugin
module.exports = {"adListItem":"MyS7ZYp9","adPlaceholder":"N3ufHhjf"};